import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

if (process.env.NODE_ENV !== 'development') Sentry.init({ dsn: 'https://5bfc402a0f044e65918d5ae3c4b341d1@o173594.ingest.sentry.io/5739682' });

hydrate();
